"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("./utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["", " ", "(", ") {\n                        ", " (", ") ", "\n                    }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var filterTypes = Symbol();

var Binding =
/*#__PURE__*/
function () {
  function Binding(_ref) {
    var introspectionResult = _ref.introspectionResult,
        client = _ref.client;
    (0, _classCallCheck2.default)(this, Binding);
    this.client = client;
    this.userTypes = this[filterTypes](introspectionResult.__schema);
    this.query = this.getMethods('query', introspectionResult.__schema);
    this.mutation = this.getMethods('mutation', introspectionResult.__schema);
  }

  (0, _createClass2.default)(Binding, [{
    key: filterTypes,
    value: function value(_ref2) {
      var types = _ref2.types,
          queryType = _ref2.queryType,
          mutationType = _ref2.mutationType;
      return _lodash.default.filter(types, function (_ref3) {
        var name = _ref3.name,
            kind = _ref3.kind;
        return name !== queryType.name && name !== mutationType.name && !_lodash.default.startsWith(name, '__') && _lodash.default.includes(['OBJECT', 'INTERFACE', 'UNION'], kind);
      });
    }
  }, {
    key: "setClient",
    value: function setClient(client) {
      this.client = client;
    }
  }, {
    key: "getMethods",
    value: function getMethods(operationType, _ref4) {
      var _this = this;

      var queryType = _ref4.queryType,
          mutationType = _ref4.mutationType;
      var sourceType = operationType === 'query' ? queryType : mutationType;
      return _lodash.default.reduce(sourceType.fields, function (operations, field) {
        return _objectSpread({}, operations, (0, _defineProperty2.default)({}, field.name, function (args, projection, fetchPolicy) {
          var _queryParams;

          var typemap = _this.getTypeMap(_this.userTypes, args);

          var fieldTypeDefinition = (0, _utils.unwrapTypeDefinition)(field.type);
          var selectionSet = ''; // CASE OF fieldTypeDefinition.kind EQUALS SCALAR OR ENUM

          if (fieldTypeDefinition.kind === 'INTERFACE' || fieldTypeDefinition.kind === 'UNION') {
            var hasSubscription = _lodash.default.get(args, 'data.subscribe', false);

            var childTypeName = hasSubscription ? 'AsyncRequest' : (0, _utils.typeUpperToCamelCase)(args.entity);

            var childTypeDescriptor = _lodash.default.find(_this.userTypes, {
              name: childTypeName
            });

            var interfaceSelection = projection && !hasSubscription ? _this.projectionToSelectionSet(projection, childTypeDescriptor, (0, _utils.typeUpperToCamelCase)(args.entity), typemap) : typemap[childTypeName];
            selectionSet = "{ ... on ".concat(childTypeName, " ").concat(interfaceSelection, " }");
          }

          if (fieldTypeDefinition.kind === 'OBJECT') {
            var typeDescriptor = _lodash.default.find(_this.userTypes, {
              name: fieldTypeDefinition.name
            });

            selectionSet = projection ? _this.projectionToSelectionSet(projection, typeDescriptor, (0, _utils.typeUpperToCamelCase)(args.entity), typemap) : typemap[fieldTypeDefinition.name];
          }

          var argumentsSection = _lodash.default.chain(args).keys().map(function (key) {
            return "".concat(key, ": $").concat(key);
          }).join(', ').value();

          var formalParams = _lodash.default.chain(field.args).map(function (arg) {
            return "$".concat(arg.name, ": ").concat((0, _utils.typeDefinitionToString)(arg.type));
          }).join(', ').value();

          var queryParams = (_queryParams = {}, (0, _defineProperty2.default)(_queryParams, operationType, (0, _graphqlTag.default)(_templateObject(), operationType, field.name, formalParams, field.name, argumentsSection, selectionSet)), (0, _defineProperty2.default)(_queryParams, "variables", args), _queryParams);

          if (fetchPolicy) {
            queryParams.fetchPolicy = fetchPolicy;
          }

          return _this.client[operationType === 'query' ? operationType : 'mutate'](queryParams).then(function (_ref5) {
            var data = _ref5.data;
            return JSON.parse(JSON.stringify(data[field.name]), function (key, value) {
              return key === '__typename' ? undefined : value;
            });
          });
        }));
      }, {});
    } // CONVERTS DESTRUCTURED ABSTRACT SYNTAX TREE TO MAPPING TYPE_NAME -> DEEP_SELECTION_SET

  }, {
    key: "getTypeMap",
    value: function getTypeMap(types, args) {
      var getSelectionSet = (0, _utils.memoize)(function (type) {
        var typeDefinition = _lodash.default.isObject(type) ? type : _lodash.default.find(types, {
          name: type
        });

        if (!typeDefinition) {
          return '';
        }

        return "{\n                ".concat(_lodash.default.chain(typeDefinition.fields).map(function (field) {
          var fieldTypeName = (0, _utils.unwrapTypeDefinition)(field.type).name;
          var selectionSet = getSelectionSet(fieldTypeName);

          if (selectionSet) {
            return "".concat(field.name, " ").concat(selectionSet);
          }

          if (field.name === 'deletedDate') {
            return "deletedDate @include(if: ".concat(_lodash.default.get(args, 'params.includeDeleted', false), ")");
          }

          return field.name;
        }).join(' ').value(), "\n                }");
      }, function (type) {
        return type.name || type;
      });
      return _lodash.default.chain(types).reduce(function (currTypeMap, type) {
        return _objectSpread({}, currTypeMap, (0, _defineProperty2.default)({}, type.name, getSelectionSet(type)));
      }, {}).value();
    } // CONVERTS EXISTING ARRAY PROJECTION TO DEEP_SELECTION_SET WITH

  }, {
    key: "projectionToSelectionSet",
    value: function projectionToSelectionSet(projection, typeDescriptor, concreteTypeName, typemap) {
      var _this2 = this;

      if (_lodash.default.isString(projection)) {
        return projection;
      }

      var buildLevel = function buildLevel(paths, currentTypeDescriptor) {
        return _lodash.default.chain(paths).reduce(function (currLevel, path) {
          return _objectSpread({}, currLevel, (0, _defineProperty2.default)({}, path[0], path.length > 1 ? [].concat((0, _toConsumableArray2.default)(currLevel[path[0]] || []), [_lodash.default.slice(path, 1)]) : []));
        }, {}).map(function (path, key) {
          var childFieldDescriptor = _lodash.default.find(currentTypeDescriptor.fields, {
            name: key
          });

          var childTypeDefinition = (0, _utils.unwrapTypeDefinition)(childFieldDescriptor.type);

          if (!_lodash.default.includes(['OBJECT', 'INTERFACE', 'UNION'], childTypeDefinition.kind)) {
            return key;
          }

          if (childTypeDefinition.kind === 'INTERFACE' || childTypeDefinition.kind === 'UNION') {
            var subtypeTypeDescriptor = _lodash.default.find(_this2.userTypes, {
              name: concreteTypeName
            });

            var _newLevel = buildLevel(path, subtypeTypeDescriptor);

            if (_newLevel) {
              return "".concat(key, " { ... on ").concat(concreteTypeName, " { ").concat(_newLevel, " } }");
            }

            return "".concat(key, " { ...on ").concat(concreteTypeName, " ").concat(typemap[subtypeTypeDescriptor.name], " }");
          }

          var childTypeDescriptor = _lodash.default.find(_this2.userTypes, {
            name: childTypeDefinition.name
          });

          var newLevel = buildLevel(path, childTypeDescriptor);

          if (newLevel) {
            return "".concat(key, " { ").concat(newLevel, " }");
          }

          return "".concat(key, " ").concat(typemap[childTypeDescriptor.name]);
        }).join(' ').value();
      };

      var paths = _lodash.default.map(projection, function (stringPath) {
        return _lodash.default.split(stringPath, '.');
      });

      var level = buildLevel(paths, typeDescriptor);

      if (!level) {
        return '';
      }

      return "{ ".concat(level, " }");
    }
  }]);
  return Binding;
}();

exports.default = Binding;